export const isStripeClearingPayment = (cashAccountId?: string, clearingCashAccountId?: string): boolean =>
  Boolean(cashAccountId && clearingCashAccountId && cashAccountId === clearingCashAccountId)
